// extracted by mini-css-extract-plugin
module.exports = {"sliderButton":"next-slider-Btn-module--slider-button--2HX2g"};